import { render, staticRenderFns } from "./ChildrenFull.vue?vue&type=template&id=05b02751"
import script from "./ChildrenFull.vue?vue&type=script&lang=js"
export * from "./ChildrenFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports